var map = {
	"./ar.json": 27333,
	"./availableLanguages.json": 37252,
	"./bg.json": 73753,
	"./bn.json": 70646,
	"./cs.json": 19504,
	"./da.json": 4149,
	"./de.json": 90369,
	"./el.json": 3835,
	"./en.json": 10389,
	"./es.json": 18302,
	"./fi.json": 559,
	"./fr.json": 75222,
	"./gu.json": 31754,
	"./hi.json": 92865,
	"./hr.json": 35276,
	"./hu.json": 36909,
	"./id.json": 66335,
	"./is.json": 12786,
	"./it.json": 34895,
	"./ja.json": 3979,
	"./km.json": 94350,
	"./kn.json": 45423,
	"./ko.json": 53532,
	"./lo.json": 58039,
	"./lt.json": 77742,
	"./lv.json": 18140,
	"./ml.json": 87491,
	"./mr.json": 83697,
	"./ms.json": 92662,
	"./my.json": 17964,
	"./ne.json": 56787,
	"./nl.json": 26920,
	"./no.json": 69093,
	"./or.json": 93887,
	"./pl.json": 99026,
	"./pt.json": 98010,
	"./ro.json": 77825,
	"./ru.json": 80671,
	"./si.json": 32346,
	"./sk.json": 85608,
	"./sr.json": 8611,
	"./sv.json": 10991,
	"./sw.json": 4924,
	"./ta.json": 9061,
	"./te.json": 46801,
	"./th.json": 72546,
	"./tl.json": 91870,
	"./tr.json": 77304,
	"./uk.json": 58230,
	"./ur.json": 85385,
	"./vi.json": 86719,
	"./zh.json": 99872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9533;